"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _setBreakPoint = _interopRequireDefault(require("../../../utils/setBreakPoint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n\t", ";\n\t", ";\n\tborder: 0;\n\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Cell = _styledComponents.default.td(_templateObject(), _spacing.default.s2, function (props) {
  return props.center && 'text-align: center';
}, function (props) {
  return props.onClick && 'cursor: pointer';
}, function (props) {
  var showFrom = (0, _setBreakPoint.default)(props.showFrom);
  return "\n\t\t\t@media screen and (max-width: " + showFrom + ") {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t@media screen and (min-width: " + showFrom + ") {\n\t\t\t\tdisplay: " + (showFrom ? 'table-cell' : 'none') + ";\n\t\t\t}\n\t\t";
});

Cell.displayName = 'Cell';
/* @component */

var _default = Cell;
exports.default = _default;